import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/profile/banner.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { class: "banner" }

import { ref, computed } from 'vue'
import HeadCard from './components/headCard.vue'
import VipCard from './components/vipCard.vue'
import MenuCard from './components/menuCard.vue'
import DownloadPanel from '../home/components/downloadPanel.vue'
import MediaSection from '../home/components/mediaSection.vue'
import FooterText from '../home/components/footerText.vue'
import { ProfilePoupData } from '@/view/profile/supportScript'


export default /*@__PURE__*/_defineComponent({
  __name: 'profilePopup',
  props: {
    dataSet: {}
  },
  emits: ['close', 'clickBanner', 'update:show'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})
const emits = __emit


const close = () => {
    emits('close')
}
const clickBanner = () => {
    emits('clickBanner')
}

const isComponentVisible = (item: any, menuId: string) => {
    return (
        item.component_id === props.dataSet.componentIdsInOrderConfig[menuId] && item.display
    );
};
__expose({
    open,
    close
})


return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    style: {
        minWidth: '100%',
        minHeight: '100%',
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(HeadCard),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: _normalizeClass({ 'pop-animate': _ctx.dataSet?.isPopping }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clickBanner()))
          }, null, 2)
        ]),
        _createVNode(VipCard),
        _createVNode(MenuCard),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.componentList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (isComponentVisible(item, 'AppDownload'))
              ? (_openBlock(), _createBlock(DownloadPanel, {
                  key: 0,
                  itemData: item
                }, null, 8, ["itemData"]))
              : _createCommentVNode("", true),
            (isComponentVisible(item, 'shareMedia'))
              ? (_openBlock(), _createBlock(MediaSection, {
                  key: 1,
                  itemData: item
                }, null, 8, ["itemData"]))
              : _createCommentVNode("", true),
            (isComponentVisible(item, 'footerText'))
              ? (_openBlock(), _createBlock(FooterText, {
                  key: 2,
                  itemData: item
                }, null, 8, ["itemData"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})